var map = {
	"./Archerss7.jpeg": 3817,
	"./Asteratitan.jpeg": 8855,
	"./Asterax9.jpeg": 4412,
	"./Aurora.jpeg": 293,
	"./Iw1915.jpeg": 4381,
	"./Phantom.jpeg": 2498,
	"./SMART BAT BIANCA.jpg": 5240,
	"./Smartbatnero.jpeg": 2087,
	"./Tabled.jpeg": 9637,
	"./lucciola.jpg": 7038,
	"./lw1941.jpeg": 4805,
	"./min i fresnel a scarica 250w.jpg": 3651,
	"./pixel bar.jpg": 2037,
	"./q7.jpg": 1252,
	"./qps led 100w.jpg": 9823,
	"./sagitter-sagoled-300.jpg": 8887,
	"./sago led 70 w.jpg": 559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9005;